// export const GOOGLE_RECAPTCHA_SITE_KEY      = "6LdjWSgqAAAAACPsLSjrrkhn0tA36r2yHONXpBsr";
// export const GOOGLE_RECAPTCHA_SECRET_KEY    = "6LdjWSgqAAAAAAiz7fbQYxhsII-ZIuFzixHKbx3g";

export const GOOGLE_RECAPTCHA_SITE_KEY      = "6Ldf4ygqAAAAAPRc6RUamfPyvSMIZqio4t7Z7pDw";
export const GOOGLE_RECAPTCHA_SECRET_KEY    = "6Ldf4ygqAAAAACazQlEP_kJCJ45AwLg5SMfy8LMQ";

export const GOOGLE_OAUTH_CLIENT_ID         = "3027197740-p7hd0enan1amcnl95p9nho835t0pkeka.apps.googleusercontent.com";
export const GOOGLE_OAUTH_CLIENT_SECRET     = "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";

export const FACEBOOK_OAUTH_APP_ID          = "550956477495838";

// export const REACT_APP_URL = "http://157.66.100.67:3000";
// export const REACT_APP_WEB_SERVER_URL = "http://157.66.100.67:4000";
// export const REACT_APP_API_ENDPOINT_URL = "http://157.66.100.67:4000/api";
// export const REACT_APP_UPLOADS_ENDPOINT_URL = "http://157.66.100.67:4000/uploads";

// export const REACT_APP_URL = "http://clinic.moctrasoft.com";
// export const REACT_APP_WEB_SERVER_URL = "http://moctrasoft.com:4000";
// export const REACT_APP_API_ENDPOINT_URL = "http://moctrasoft.com:4000/api";
// export const REACT_APP_UPLOADS_ENDPOINT_URL = "http://moctrasoft.com:4000/uploads";

// export const REACT_APP_URL = "https://phongkham.moctrasoft.com";
// export const REACT_APP_WEB_SERVER_URL = "https://api.moctrasoft.com";
// export const REACT_APP_API_ENDPOINT_URL = "https://api.moctrasoft.com/api";
// export const REACT_APP_UPLOADS_ENDPOINT_URL = "https://api.moctrasoft.com/uploads";

export const API_SUB_URL_COMPANY     = '/companies';
export const API_SUB_URL_DOCTOR      = '/doctors';
export const API_SUB_URL_DEPARTMENT  = '/departments';
export const API_SUB_URL_PATIENT     = '/patients';
export const API_SUB_URL_SCHEDULE_MEDICAL     = '/schedule_medicals';
export const API_SUB_URL_PATIENT_RESULT = '/patient_results';
export const API_SUB_URL_USER        = '/users';
export const API_SUB_URL_SERVICE_PRICE = '/service_prices';
export const API_SUB_URL_MEDICINE    = '/medicines';
export const API_SUB_URL_MEDICINE_IMPORT_EXPORT    = '/medicine_import_exports';
export const API_SUB_URL_ENTERPRISE  = '/enterprises';
export const API_SUB_URL_SYSTEM_SETTING        = '/system_settings';
export const API_SUB_URL_USER_LOG    = '/user_logs';
export const API_SUB_URL_PAYMENT    = '/payments';
export const API_SUB_URL_EXPORT_CSV_FILE       = '/export_csv_file';
export const API_SUB_URL_EXPORT_EXCEL_FILE     = '/export_excel_file';
export const API_SUB_URL_EMAIL       = '/emails';

export const NORMAL_MAX_AGE = 30*60;
export const LOGIN_MAX_AGE = 1*60*60;
export const PATIENT_INFORMATION_MAX_AGE = 1*60*60;
export const SELECTED_CLINIC_MAX_AGE = 30*24*60*60;

export const FLOOR_LIST = {
    0: "TẦNG TRỆT",
    1: "TẦNG 1",
    2: "TẦNG 2",
    3: "TẦNG 3",
    4: "TẦNG 4",
    5: "TẦNG 5",
    6: "TẦNG 6",
    7: "TẦNG 7",
    8: "TẦNG 8",
}

export const FLOOR_LIST_EN = {
    0: "GROUND",
    1: "FLOOR 1",
    2: "FLOOR 2",
    3: "FLOOR 3",
    4: "FLOOR 4",
    5: "FLOOR 5",
    6: "FLOOR 6",
    7: "FLOOR 7",
    8: "FLOOR 8",
}

export const GENDER = {
    "NAM": "NAM",
    "NỮ": "NỮ",
    "KHÁC": "KHÁC",
};

export const WORK_DAILY_SETTING     = "WORK_DAILY_SETTING";
export const WORK_HOURLY_SETTING    = "WORK_HOURLY_SETTING";
export const PATIENT_RESULT_SETTING = "PATIENT_RESULT_SETTING";
export const FOOD_AVOID_SETTING     = "FOOD_AVOID_SETTING";
export const PAYMENT_SETTING        = "PAYMENT_SETTING";

export const WORK_DAILY_LIST = {
    "Thứ 2": true,
    "Thứ 3": true,
    "Thứ 4": true,
    "Thứ 5": true,
    "Thứ 6": true,
    "Thứ 7": true,
    "Chủ nhật": true,
}

export const WORK_HOURLY_LIST = {
    "00:00 - 01:00": false,
    "01:00 - 02:00": false,
    "02:00 - 03:00": false,
    "03:00 - 04:00": false,
    "04:00 - 05:00": false,
    "05:00 - 06:00": false,
    "06:00 - 07:00": false,
    "07:00 - 08:00": true,
    "08:00 - 09:00": true,
    "09:00 - 10:00": true,
    "10:00 - 11:00": true,
    "11:00 - 12:00": true,
    "12:00 - 13:00": false,
    "13:00 - 14:00": true,
    "14:00 - 15:00": true,
    "15:00 - 16:00": true,
    "16:00 - 17:00": true,
    "17:00 - 18:00": true,
    "18:00 - 19:00": false,
    "19:00 - 20:00": false,
    "20:00 - 21:00": false,
    "21:00 - 22:00": false,
    "22:00 - 23:00": false,
    "23:00 - 24:00": false,
}

export const ROLES = {
    "admin": "Quyền Admin (thao tác thêm, sửa, xoá dữ liệu)",
    "normal": "Quyền User (chỉ được xem)"
};

// export const ROLES = [
//     { id: 1, name: "Quyền Admin", value: "admin" },
//     { id: 2, name: "Quyền User", value: "normal" },
// ];

export const SUCCESS_STATUS = "SUCCESS";
export const FAILED_STATUS = "FAILED";

export const MEDICAL_WAITING_STATUS = {
    "PROCESSING": "ĐANG CHỜ KHÁM",
    "FINISHED": "KHÁM XONG",
    "PENDING": "HOÃN KHÁM",
    "CANCEL": "HUỶ KHÁM"
}

export const MEDICAL_WAITING_STATUS_EN = {
    "PROCESSING": "PROCESSING",
    "FINISHED": "FINISHED",
    "PENDING": "PENDING",
    "CANCEL": "CANCEL"
}

export const ALL = "ALL";
export const FINISHED_STATUS = "FINISHED";
export const PROCESSING_STATUS = "PROCESSING";
export const PENDING_STATUS = "PENDING";
export const CANCEL_STATUS = "CANCEL";
export const PAID_STATUS = "PAID";

export const MAIN_COLOR = "#027240";

export const PATIENT_RESULT_TYPES = [
    {type: "Chuẩn đoán", size: "LARGE"},
    {type:"Đề nghị", size: "LARGE"},
]

export const FOOD_AVOIDS = [
    { value: "Thuốc lá" },
    { value: "Rượu bia" },
    { value: "Mặn" },
    { value: "Ngọt mỡ" }
]

export const SIZE_LIST = [
    { id: 1, code: "SMALL", label: "Bình thường" },
    { id: 2, code: "LARGE", label: "Lớn" },
    { id: 3, code: "VERY_LARGE", label: "Rất Lớn" },
]

export const REGISTER_TYPE = {
    "NEW": "ĐĂNG KÝ MỚI",
    "EXTEND": "GIA HẠN"
}

export const REGISTER_TYPE_EN = {
    "NEW": "NEW REGISTER",
    "EXTEND": "EXTEND"
}

export const PRICING_LIST = {
    "FREE": { 
        label: "Miễn Phí",
        price: "0 VND /gói",
        old_price: "0 VND /gói",
        period: "2 tháng",
        context: [
            { isBold: true, text: "Sử dụng tối đa cho 500 bệnh nhân" },
            { isBold: false, text: "Đăng ký lịch khám online" },
            { isBold: false, text: "Quản lý thông tin phòng chức năng, bác sỹ" },
            { isBold: false, text: "Quản lý kết quả khám của bệnh nhân" },
            { isBold: false, text: "Thông báo, trả kết quả khám qua mã QR Code, Email" },
            { isBold: false, text: "Quản lý kho thuốc" }
        ],
        amount: 0,
        max_user_register: 1,
        total_month_actived: 2
    },
    "BASIC": { 
        label: "Cơ Bản",
        price: "1.500.000 VND /gói",
        old_price: "2.500.000 VND /gói",
        period: "1 năm",
        context: [
            { isBold: true, text: "Sử dụng tối đa cho 2000 bệnh nhân" },
            { isBold: false, text: "Đăng ký lịch khám online" },
            { isBold: false, text: "Quản lý thông tin phòng chức năng, bác sỹ" },
            { isBold: false, text: "Quản lý kết quả khám của bệnh nhân" },
            { isBold: false, text: "Thông báo, trả kết quả khám qua mã QR Code, Email" },
            { isBold: false, text: "Quản lý kho thuốc" },
            { isBold: false, text: "Quản lý khám sức khoẻ cho doanh nghiệp, công ty" },
            { isBold: false, text: "Tích hợp thanh toán online khi bệnh nhân đặt lịch khám" },
        ],
        amount: 1500000,
        max_user_register: 5,
        total_month_actived: 12
    },
    "PRO": { 
        label: "Chuyên Nghiệp", 
        price: "2.000.000 VND /gói",
        old_price: "4.000.000 VND /gói",
        period: "1 năm",
        context: [
            { isBold: true, text: "Không giới hạn số lượng bệnh nhân" },
            { isBold: false, text: "Đăng ký lịch khám online" },
            { isBold: false, text: "Quản lý thông tin phòng chức năng, bác sỹ" },
            { isBold: false, text: "Quản lý kết quả khám của bệnh nhân" },
            { isBold: false, text: "Thông báo, trả kết quả khám qua mã QR Code, Email" },
            { isBold: false, text: "Thông báo, trả kết quả khám qua Zalo" },
            { isBold: false, text: "Quản lý kho thuốc" },
            { isBold: false, text: "Quản lý khám sức khoẻ cho doanh nghiệp, công ty" },
            { isBold: false, text: "Tích hợp thanh toán online khi bệnh nhân đặt lịch khám" },
        ], 
        amount: 2000000,
        max_user_register: 10000,
        total_month_actived: 12
    },
}

export const PRICING_LIST_EN = {
    "FREE": { 
        label: "FREE",
        price: "0 VND",
        old_price: "0 VND",
        period: "2 months",
        context: [
            { isBold: true, text: "Alow create maximum 500 patient" },
            { isBold: false, text: "Register medical schedule online" },
            { isBold: false, text: "Management specialists, doctors" },
            { isBold: false, text: "Management patient's result" },
            { isBold: false, text: "Management medicine warehouse" },
            { isBold: false, text: "Report, return patient's result through QR Code, email" },
        ],
        amount: 0,
        max_user_register: 1,
        total_month_actived: 2
    },
    "BASIC": { 
        label: "BASIC",
        price: "1.500.000 VND",
        old_price: "2.500.000 VND",
        period: "1 year",
        context: [
            { isBold: true, text: "Alow create maximum 2000 patient" },
            { isBold: false, text: "Register medical schedule online" },
            { isBold: false, text: "Management specialists, doctors" },
            { isBold: false, text: "Management patient's result" },
            { isBold: false, text: "Management medicine warehouse" },
            { isBold: false, text: "Report, return patient's result through QR Code, email" },
            { isBold: false, text: "Management medical test for enterprise, company" },
            { isBold: false, text: "Intergate online payment" },
        ],
        amount: 1500000,
        max_user_register: 5,
        total_month_actived: 12
    },
    "PRO": { 
        label: "PRO", 
        price: "2.000.000 VND",
        old_price: "4.000.000 VND",
        period: "1 year",
        context: [
            { isBold: true, text: "No limit create patient" },
            { isBold: false, text: "Register medical schedule online" },
            { isBold: false, text: "Management specialists, doctors" },
            { isBold: false, text: "Management patient's result" },
            { isBold: false, text: "Management medicine warehouse" },
            { isBold: false, text: "Report, return patient's result through QR Code, email" },
            { isBold: false, text: "Management medical test for enterprise, company" },
            { isBold: false, text: "Intergate online payment" },
        ], 
        amount: 2000000,
        max_user_register: 10000,
        total_month_actived: 12
    },
}

export const PAYMENT_SUPPLIERS = {
    "PAYOS": "PAYOS",
    "VNPAY": "VNPAY"
}

export const PAYMENT_STATUS = {
    "PAID": "ĐÃ THANH TOÁN",
    "PENDING": "CHỜ THANH TOÁN",
    "FAILED": "THẤT BẠI"
}

export const REGISTER_COMPANY = "register_company";
export const EXTEND_COMPANY = "extend_company";
export const MAKE_DOCTOR_APPOINTMENT = "make_doctor_appointment";

export const PAYMENT_TYPES = {
    "register_company": "Đăng ký mới phòng khám",
    "extend_company": "Gia hạn phòng khám",
    "make_doctor_appointment": "Đặt lịch khám"
};

export const ERROR_CODES = {
    "ERR_NETWORK": "Mất kết nối tới server!"
}
